import User from "@/models/User";
import api from "@/api";
import axios from "axios";

const state = {
  user: null,
  token: null,
  test: "x"
};
const getters = {
  check: state => {
    return state.token && state.user ? true : false;
  },
  user: state => {
    let user = state.user ? new User(state.user) : null;
    // if (user) {
    //   user.user_type = 2;
    // }
    return user;
  },
  token: state => {
    return state.token ? state.token : null;
  },
  test: state => {
    return state.test;
  }
};
const actions = {
  async login({ commit }, payload) {
    if (payload.username != "" && payload.password != "") {
      var data = {
        grant_type: api.grant_type,
        client_id: api.client_id,
        client_secret: api.client_secret,
        username: payload.username,
        password: payload.password
      };
      var url = new URL("/o/token/", api.baseUrl);
      // Allow overriding token endpoint via environment variable VUE_APP_TOKEN_URL
      // Example: VUE_APP_TOKEN_URL=https://auth.example.com/o/token/
      if (process && process.env && process.env.VUE_APP_TOKEN_URL) {
        url = process.env.VUE_APP_TOKEN_URL;
      }
      var params = new URLSearchParams(Object.entries(data));
      const resp = await axios({
        method: "post",
        url: url,
        crossdomain: true,
        data: params.toString(),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (resp && resp.status == 200) {
        commit("setToken", {
          token: { ...resp.data },
          user: { username: payload.username }
        });
        commit("initUser");
        return resp;
      }
      return null;
    }
  },
  async getUserInfo({ state, commit }, payload) {
    if (payload === undefined) {
      const resp = await api.get(`/api/v1/users/info/${state.user.username}/`);
      if (resp && resp.status == 200) {
        commit("setUser", resp.data.data[0]);
        return resp;
      }
    } else {
      const resp = await api.get(`/api/v1/users/info/${payload.username}/`);
      if (resp && resp.status == 200) {
        commit("setUser", resp.data.data[0]);
        return resp.data.data[0];
      }
    }
  },
  async logout({ commit, state }) {
    if (state.token) {
      const resp = await api.post("/o/revoke_token/", {
        token: state.token.access_token,
        client_id: api.client_id
      });
      commit("clearToken");
      return resp;
    } else {
      commit("clearToken");
    }
  },
  init: ({ commit }) => {
    commit("initToken");
    commit("initUser");
  }
};
const mutations = {
  initUser: state => {
    let app_storage = JSON.parse(window.localStorage.getItem("app_storage"));
    state.test = app_storage;
    if (app_storage) state.user = app_storage.user;
    else state.user = null;
  },
  initToken: state => {
    let app_storage = JSON.parse(window.localStorage.getItem("app_storage"));
    if (app_storage) state.token = app_storage.token;
    else state.token = null;
  },
  setUser: (state, payload) => {
    let app_storage = JSON.parse(window.localStorage.getItem("app_storage"));
    if (app_storage) {
      app_storage.user = payload;
      window.localStorage.setItem("app_storage", JSON.stringify(app_storage));
    }
    state.user = new User(payload);
  },
  setToken: (state, payload) => {
    window.localStorage.setItem("app_storage", JSON.stringify(payload));
    state.token = payload.token;
    state.user  = payload.user;
  },
  clearUser: state => {
    window.localStorage.removeItem("app_user");
    state.user = null;
  },
  clearToken: state => {
    window.localStorage.removeItem("app_storage");
    state.token = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
